"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SubscriptionStatus = exports.PaymentType = exports.SubscriptionType = void 0;
var SubscriptionType;
(function (SubscriptionType) {
    SubscriptionType["monthly"] = "monthly";
    SubscriptionType["annual"] = "annual";
})(SubscriptionType = exports.SubscriptionType || (exports.SubscriptionType = {}));
var PaymentType;
(function (PaymentType) {
    PaymentType["subscription"] = "subscription";
    PaymentType["liveWorkout"] = "liveWorkout";
    PaymentType["event"] = "event";
    PaymentType["program"] = "program";
})(PaymentType = exports.PaymentType || (exports.PaymentType = {}));
var SubscriptionStatus;
(function (SubscriptionStatus) {
    SubscriptionStatus["incomplete"] = "incomplete";
    SubscriptionStatus["incompleteExpired"] = "incomplete_expired";
    SubscriptionStatus["trialing"] = "trialing";
    SubscriptionStatus["active"] = "active";
    SubscriptionStatus["pastDue"] = "past_due";
    SubscriptionStatus["canceled"] = "canceled";
    SubscriptionStatus["unpaid"] = "unpaid";
})(SubscriptionStatus = exports.SubscriptionStatus || (exports.SubscriptionStatus = {}));
